import React, { useState, useEffect } from "react";
import { bool, shape, string } from "prop-types";
import Button from "pages/_components/Button";
import { useDispatch, useSelector } from "react-redux";
import Drawer from "pages/_components/Drawer/Drawer";
import TableFrequentDestination from "pages/frequentDestination/_components/TableFrequentDestination";
import { actions as debinActions } from "reducers/debin";
import GridTable from "pages/_components/GridTable/GridTable";
import Avatar from "pages/_components/Avatar";
import * as i18n from "util/i18n";
import FieldLabel from "pages/_components/fields/FieldLabel";
import AddBeneficiary from "./AddBeneficiary";
import { actions as contactActions } from "reducers/contactDestination";

const FORM_ID = "echeqs.emit";

const Beneficiaries = ({ isDesktop, beneficiaryData, actionType }) => {
    const dispatch = useDispatch();
    const [openSidebar, setOpenSidebar] = useState(false);
    const [openSidebarForm, setOpenSidebarForm] = useState(false);
    const [beneficiary, setBeneficiary] = useState({});
    const { cbuBlocked, fetching } = useSelector((state) => state.contactDestination);

    const selectBeneficiary = (beneficiary) => {
        dispatch(
            contactActions.validateCbuBlocked({
                creditCbu: beneficiary.cbu,
            }),
        );

        setBeneficiary(beneficiary);
        setOpenSidebar(false);
    };

    const cleanBeneficiary = () => {
        dispatch(debinActions.setBeneficiary({}));
    };

    useEffect(() => {
        if (cbuBlocked === false) {
            dispatch(debinActions.setBeneficiary(beneficiary));
        }
    }, [cbuBlocked]);

    return (
        <>
            <GridTable.Container columns={12} columnsTemplate="fixed" className="mb-4">
                <GridTable.Data columnStart={2} columnWidth={10} className="mb-4">
                    <FieldLabel labelText={i18n.get("debin.beneficiary")} />
                </GridTable.Data>
                <GridTable.Data columnStart={2} columnWidth={3}>
                    <Button
                        className="btn-outline"
                        label="echecks.search.contact"
                        onClick={() => setOpenSidebar(true)}
                        disabled={beneficiaryData?.document}
                        loading={fetching}
                    />
                </GridTable.Data>
                <GridTable.Data columnStart={5} columnWidth={3}>
                    <Button
                        className="btn-outline"
                        label="echecks.new.contact"
                        onClick={() => setOpenSidebarForm(true)}
                        disabled={beneficiaryData?.document}
                        loading={fetching}
                    />
                </GridTable.Data>
            </GridTable.Container>
            {beneficiaryData?.cbu && (
                <GridTable.Container columns={12} columnsTemplate="fixed" className="debin__solicit-beneficiary">
                    <GridTable.Data columnStart={2} columnWidth={10}>
                        <GridTable.Container
                            className="beneficiary box border blocktag mb-4"
                            columns={12}
                            columnsTemplate="fixed">
                            <GridTable.Data columnStart={1} columnWidth={1}>
                                <Avatar
                                    user={{
                                        userFullName: beneficiaryData?.name || beneficiaryData?.recipientName,
                                        defaultAvatarId: 0,
                                        email: beneficiaryData?.email,
                                    }}
                                />
                            </GridTable.Data>
                            <GridTable.Data columnStart={2} columnWidth={8} alignY="center">
                                <span>{`${beneficiaryData?.name || beneficiaryData?.recipientName}`}</span>
                            </GridTable.Data>
                            <GridTable.Data columnStart={12} columnWidth={1} className="close" alignX="center">
                                <Button
                                    onClick={() => cleanBeneficiary()}
                                    image="images/figma/icon/cross.svg"
                                    bsStyle="link"
                                />
                            </GridTable.Data>
                        </GridTable.Container>
                    </GridTable.Data>
                </GridTable.Container>
            )}
            <Drawer openSidebar={openSidebar} toggleSidebar={setOpenSidebar}>
                <TableFrequentDestination
                    formId={FORM_ID}
                    onRowClick={selectBeneficiary}
                    searchClassName="d-flex flex-column"
                    isDesktop={isDesktop}
                    fromModal
                />
            </Drawer>
            <Drawer openSidebar={openSidebarForm} toggleSidebar={setOpenSidebarForm}>
                <AddBeneficiary
                    type={actionType}
                    setOpenSidebarForm={setOpenSidebarForm}
                    selectBeneficiary={selectBeneficiary}
                />
            </Drawer>
        </>
    );
};

Beneficiaries.propTypes = {
    isDesktop: bool.isRequired,
    beneficiaryData: shape({}),
    actionType: string.isRequired,
};

Beneficiaries.defaultProps = {
    beneficiaryData: {},
};

export default Beneficiaries;
